module.exports = __webpack_public_path__ + "img/GAME_MULTI OMOK2.c4645740.jpg";